export enum rawOptions {
    tmp = 'tmp',
    pmat = 'pmat',
    pmst = 'pmst',
    pmglp = 'pmglp',
    alarm1s = 'alarm1s',
    alarm1t = 'alarm1t',
    alarm1wt = 'alarm1wt',
    alarm1a = 'alarm1a',
    alarm2s = 'alarm2s',
    alarm2t = 'alarm2t',
    alarm2wt = 'alarm2wt',
    alarm2a = 'alarm2a',
    alarm3s = 'alarm3s',
    alarm3t = 'alarm3t',
    alarm3wt = 'alarm3wt',
    alarm3a = 'alarm3a',
    alarm4s = 'alarm4s',
    alarm4t = 'alarm4t',
    alarm4wt = 'alarm4wt',
    alarm4a = 'alarm4a',
    alarm5s = 'alarm5s',
    alarm5t = 'alarm5t',
    alarm5wt = 'alarm5wt',
    alarm5a = 'alarm5a',
    alarm6s = 'alarm6s',
    alarm6t = 'alarm6t',
    alarm6wt = 'alarm6wt',
    alarm6a = 'alarm6a',
    accm = 'accm',
    accps = 'accps',
    accpe = 'accpe',
    accas = 'accas',
    accds = 'accds',
    acca = 'acca',
    accat = 'accat',
    accit = 'accit',
    smss = 'smss',
    smsf = 'smsf',
    s1pn = 's1pn',
    s2pn = 's2pn',
    srv1s = 'srv1s',
    srv1p = 'srv1p',
    srv1wipsa = 'srv1wipsa',
    srv1wipsp = 'srv1wipsp',
    srv1wipspass = 'srv1wipspass',
    srv2s = 'srv2s',
    srv2p = 'srv2p',
    srv2wipsa = 'srv2wipsa',
    srv2wipsp = 'srv2wipsp',
    srv2wipspass = 'srv2wipspass',
    srv3s = 'srv3s',
    srv3p = 'srv3p',
    srv3wipsa = 'srv3wipsa',
    srv3wipsp = 'srv3wipsp',
    srv3wipspass = 'srv3wipspass',
    msc = 'msc',
    s1apn = 's1apn',
    s1login = 's1login',
    s1pass = 's1pass',
    s2apn = 's2apn',
    s2login = 's2login',
    s2pass = 's2pass',
    dns1 = 'dns1',
    dns2 = 'dns2',
    timeSyncSatsState = 'timeSyncSatsState',
    timeSyncGsmState = 'timeSyncGsmState',
    timeSyncNtpState = 'timeSyncNtpState',
    ntpsa = 'ntpsa',
    ntpsp = 'ntpsp',
    gnssm = 'gnssm',
    gnssmint = 'gnssmint',
    gnssmaxt = 'gnssmaxt',
    gnssrt = 'gnssrt',
    ftpsa = 'ftpsa',
    ftpsp = 'ftpsp',
    ftpl = 'ftpl',
    ftpp = 'ftpp',
    ftpd = 'ftpd',
    ftpfn = 'ftpfn',
    ledm = 'ledm',
    rtctz = 'rtctz',
}
